
function setTransmissionDetails(state, details) {
	state.inboundTransmission = details;
}

export default { setTransmissionDetails };